export function checkStringProperty(object, property) {
  return (
    (object[property] !== undefined || object[property] !== null) &&
    object[property]?.length > 0
  )
}
export function isValidHttpUrl(link) {
  let url

  try {
    url = new URL(link)
  } catch (_) {
    return false
  }

  return url.protocol === 'http:' || url.protocol === 'https:'
}
